import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_CONSTANTS } from 'Client/components/ListingPage/services/seo/constant';
import useRouter from 'Client/hooks/useRouter';

type SEOHeadNoIndexProps = { children?: never; noIndex: true };

type SEOHeadProps =
    | {
          children: React.ReactNode;
          noIndex?: never;
      }
    | SEOHeadNoIndexProps;

const SEOHead = ({ children, noIndex }: SEOHeadProps) => {
    const { isAppWebviewPage } = useRouter();

    return (
        <Helmet>
            <meta
                name={SEO_CONSTANTS.robotsMetaName}
                content={isAppWebviewPage || noIndex ? SEO_CONSTANTS.noIndexable : SEO_CONSTANTS.indexable}
            />
            {children}
        </Helmet>
    );
};

export default SEOHead;
